<template>
  <section class="content">
    <!-- Default box -->
    <div
      class="card card-solid"
      :style="{ 'min-height': $store.state.screenHeight - 200 + 'px' }"
    >
      <div class="card-header pb-0">
        <div class="row">
          <div class="form-group row col-sm-4 pb-0">
            <label
              for="date"
              class="col-sm-4 col-form-label text-right pb-0"
            >ลูกค้าเริ่ม</label>
            <div class="col-sm-8 pb-0">
              <a-select
                class="mr-sm-2 pb-0"
                show-search
                option-filter-prop="children"
                style="width: 100%"
                :filter-option="filterOption"
                v-model="begin_code"
              >
                <a-select-option value="">
                  -- ไม่เลือก --
                </a-select-option>
                <a-select-option
                  v-for="(b, i) in data_cus_list"
                  :key="'branch' + i"
                  :value="b.code"
                >
                  {{ b.code }}/{{ b.name }}
                </a-select-option>
              </a-select>
              <!-- <select
                class="custom-select mr-sm-2 pb-0"
                id="Host"
                v-model="begin_code"
              >
                <option value="">-- ไม่เลือก --</option>
                <option
                  v-for="(b, i) in data_cus_list"
                  :key="'branch' + i"
                  :value="b.code"
                >{{ b.name }}</option>
              </select> -->
            </div>
          </div>
          <div class="form-group row col-sm-4 pb-0">
            <label
              for="date"
              class="col-sm-4 col-form-label text-right pb-0"
            >ลูกค้าสุดท้าย</label>
            <div class="col-sm-8 pb-0">
              <a-select
                class="mr-sm-2 pb-0"
                show-search
                option-filter-prop="children"
                style="width: 100%"
                :filter-option="filterOption1"
                v-model="end_code"
              >
                <a-select-option value="">
                  -- ไม่เลือก --
                </a-select-option>
                <a-select-option
                  v-for="(b, i) in data_cus_list"
                  :key="'branch' + i"
                  :value="b.code"
                >
                  {{ b.code }}/{{ b.name }}
                </a-select-option>
              </a-select>
              <!-- <select
                class="custom-select mr-sm-2 pb-0"
                id="Host"
                v-model="end_code"
              >
                <option value="">-- ไม่เลือก --</option>
                <option
                  v-for="(b, i) in data_cus_list"
                  :key="'branch' + i"
                  :value="b.code"
                >{{ b.name }}</option>
              </select> -->
            </div>
          </div>
          <div class="form-group row col-sm-4 pb-0">
            <label
              for="date"
              class="col-sm-4 col-form-label text-right pb-0"
            >เลือกสาขา</label>
            <div class="col-sm-8 pb-0">
              <select
                class="custom-select mr-sm-2 pb-0"
                id="Host"
                v-model="branch"
                @change="onSelectBranch(branch)"
              >
                <option value="0">-- ทุกสาขา --</option>
                <option
                  v-for="(b, i) in $store.state.branch_list"
                  :key="'branch' + i"
                  :value="b"
                >{{ b.branch_name }}</option>
              </select>
            </div>
          </div>
          <!-- <div class="form-group row col-sm-4 pb-0">
            <label
              for="date"
              class="col-sm-4 col-form-label text-right pb-0"
            >เลือกจุดขาย</label>
            <div class="col-sm-8 pb-0">
              <select
                class="custom-select mr-sm-2 pb-0"
                id="Host"
                v-model="host"
              >
                <option value="0">-- ทุกจุดขาย --</option>
                <option
                  v-for="(h, i) in host_list"
                  :key="'host' + i"
                  :value="h"
                >{{ h.host_name }}</option>
              </select>
            </div>
          </div> -->
          <div class="form-group row col-sm-3 pb-0">
            <label
              for="date"
              class="col-sm-4 col-form-label text-right pb-0"
            >หมวดเริ่ม</label>
            <div class="col-sm-8 pb-0">
              <a-select
                class="mr-sm-2 pb-0"
                show-search
                option-filter-prop="children"
                style="width: 100%"
                :filter-option="filterOption"
                v-model="begin_group"
              >
                <a-select-option value="">
                  -- ไม่เลือก --
                </a-select-option>
                <a-select-option
                  v-for="(b, i) in item_group_list"
                  :key="'branch' + i"
                  :value="b.code"
                >
                  {{ b.code }}/{{ b.name }}
                </a-select-option>
              </a-select>
              <!-- <select
                class="custom-select mr-sm-2 pb-0"
                id="Host"
                v-model="begin_code"
              >
                <option value="">-- ไม่เลือก --</option>
                <option
                  v-for="(b, i) in data_cus_list"
                  :key="'branch' + i"
                  :value="b.code"
                >{{ b.name }}</option>
              </select> -->
            </div>
          </div>
          <div class="form-group row col-sm-3 pb-0">
            <label
              for="date"
              class="col-sm-4 col-form-label text-right pb-0"
            >หมวดสิ้นสุด</label>
            <div class="col-sm-8 pb-0">
              <a-select
                class="mr-sm-2 pb-0"
                show-search
                option-filter-prop="children"
                style="width: 100%"
                :filter-option="filterOption"
                v-model="end_group"
              >
                <a-select-option value="">
                  -- ไม่เลือก --
                </a-select-option>
                <a-select-option
                  v-for="(b, i) in item_group_list"
                  :key="'branch' + i"
                  :value="b.code"
                >
                  {{ b.code }}/{{ b.name }}
                </a-select-option>
              </a-select>
              <!-- <select
                class="custom-select mr-sm-2 pb-0"
                id="Host"
                v-model="begin_code"
              >
                <option value="">-- ไม่เลือก --</option>
                <option
                  v-for="(b, i) in data_cus_list"
                  :key="'branch' + i"
                  :value="b.code"
                >{{ b.name }}</option>
              </select> -->
            </div>
          </div>
          <div class="form-group row col-sm-3 pb-0">
            <label
              for="date"
              class="col-sm-4 col-form-label text-right"
            >จากวันที่</label>
            <div class="col-sm-8">
              <a-date-picker
                v-model="startDate"
                :format="'DD/MM/YYYY'"
                style="width: 100%;"
              />
            </div>
          </div>
          <div class="form-group row col-sm-3 pb-0">
            <label
              for="date"
              class="col-sm-4 col-form-label text-right"
            >ถึงวันที่</label>
            <div class="col-sm-8">
              <a-date-picker
                v-model="endDate"
                :format="'DD/MM/YYYY'"
                style="width: 100%;"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="card-body">
        <div class="row">
          <div class="col-sm-2"></div>
          <div class="col-sm-3">
            <button
              type="button"
              class="btn btn-success btn-block"
              @click="getReport"
            >
              <i class="fas fa-redo"></i> ประมวลผล
            </button>
          </div>
          <div class="col-sm-3">
            <form
              action="/static/pdf/report_sale_by_customer.php"
              method="POST"
              target="_blank"
            >
              <input
                type="hidden"
                name="date_start"
                v-model="startDate"
              >
              <input
                type="hidden"
                name="date_end"
                v-model="endDate"
              >
              <input
                type="hidden"
                name="host"
                v-model="host"
              >
              <input
                type="hidden"
                name="data"
                v-model="form_data"
              >
              <button
                type="submit"
                class="btn btn-primary btn-block"
              >
                <i class="far fa-file-pdf"></i> บันทึกเป็น PDF
              </button>
            </form>
          </div>
          <div class="col-sm-3">
            <form
              action="/static/excel/report_sale_by_customer.php"
              method="POST"
              target="_blank"
            >
              <input
                type="hidden"
                name="date_start"
                v-model="startDate"
              >
              <input
                type="hidden"
                name="date_end"
                v-model="endDate"
              >
              <input
                type="hidden"
                name="data"
                v-model="form_data"
              >
              <button
                type="submit"
                class="btn btn-info btn-block"
              >
                <i class="far fa-file-excel"></i> บันทึกเป็น Excel
              </button>
            </form>
          </div>
        </div>
        <div
          class="text-center pt-3"
          v-if="report_data.length < 1"
        >
          <h5>ไม่มีข้อมูล</h5>
        </div>
        <div
          class="table-responsive-sm mt-3"
          v-for="(c, i) in report_data"
          :key="'c' + i"
          v-show="c.pay_bill.length > 0"
        >
          <!-- {{ c.pay_bill }} -->
          <!-- <h4 class="m-1 p-1">
            สาขา: {{ (c[0])? c[0]['branch_name'] || '-' : '-' }}
            &nbsp;&nbsp;&nbsp;&nbsp; จุดขาย: {{ (c[0])? c[0]['host_code'] || '-' : '-' }}
          </h4> -->
          <div
            id="sendMoney"
            class="table table-bordered"
            v-for="(cus_d, i) in c.pay_bill"
            :key="'cus_d' + i"
          >
            <!-- <table
              id="sendMoney"
              class="table table-bordered"
            >
              <tr style="background: #ffc10782;">
                <th>ลูกค้า: {{ cus_d.ar_code }}/{{ cus_d.ar_name }}</th>
                <th>เบอร์: {{ cus_d.ar_telephone }}</th>
                <th>มูลค่ารวม: {{ cus_d.total_amount }}</th>
              </tr>
            </table> -->

            <table
              id="sendMoney"
              colspan="6"
              class="table table-bordered"
            >
              <tr style="background: #ffc10782;">
                <th colspan="4">ลูกค้า: {{ cus_d.ar_code }}/{{ cus_d.ar_name }}</th>
                <th colspan="2">เบอร์: {{ cus_d.ar_telephone }}</th>
                <th colspan="2">มูลค่ารวม: {{ numberFormatDecimal(cus_d.total_amount) }}</th>
              </tr>
              <tbody
                v-for="(d, i) in cus_d.invoice"
                :key="'d' + i"
              >
                <tr style="background: #fffed4;">
                  <th colspan="4">เลขที่บิลขาย: {{ d.doc_no }}</th>
                  <th colspan="2">วันที่: {{ dateFormatAndTime(d.create_time) }}</th>
                  <th colspan="2">ส่วนลด: {{ numberFormatDecimal(d.discount_amount) }}</th>
                </tr>
                <tr
                  class="text-center"
                  style="background: #ebf6ff;"
                >
                  <th>บาร์โค้ด</th>
                  <th>รายละอียด</th>
                  <th>ราคาต่อหน่วย</th>
                  <th>จำนวน</th>
                  <th>ส่วนลด</th>
                  <th>ราคาก่อน VAT</th>
                  <th>ภาษี 7%</th>
                  <th>รวม</th>
                </tr>
                <tr
                  v-for="(s, i) in d.sub"
                  :key="'csub' + i"
                >
                  <td>{{ s.item_barcode }}</td>
                  <td>{{ s.item_name }}</td>
                  <td class="text-right">{{ numberFormatDecimal(s.price) }}</td>
                  <td class="text-right">{{ numberFormatDecimal(s.qty) }}</td>
                  <td class="text-right">0.00</td>
                  <td class="text-right">{{ numberFormatDecimal(s.amount - s.tax_amount) }}</td>
                  <td class="text-right">{{ numberFormatDecimal(s.tax_amount) }}</td>
                  <td class="text-right">{{ numberFormatDecimal(s.amount) }}</td>
                </tr>
                <!-- <tr>
                  <td
                    class="text-right"
                    colspan="6"
                  >### รวมรายการ: {{ d.sub.length }} ###</td>
                </tr> -->
                <tr>
                  <td colspan="4">Remark: {{ d.description || '-' }}</td>
                  <td style="background: #ebf6ff;">รวมบิลขาย: {{ d.doc_no }}</td>
                  <td class="text-right">{{ numberFormatDecimal(calQTY(d.sub)) }}</td>
                  <td
                    class="text-right"
                    style="background: #ffd5d4;"
                  >0.00</td>
                  <td
                    class="text-right"
                    style="background: #e2ffd4;"
                  >{{ numberFormatDecimal(calAmount(d.sub)) }}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <!-- <h5>รวมสาขา: {{ (c[0])? c[0]['branch_name'] || '-' : '-' }}: {{ numberFormatDecimal(calAmountBranch(c)) }} บาท</h5> -->
        </div>
        <table
          style="width: 100%;"
          v-if="calAmountBranchAll(report_data) > 0"
        >
          <tr>
            <th
              style="background: #eeffeb; text-align: left;"
              class="pt-2 pl-2 pb-0"
            >
              <h5>รวมทุกสาขา: {{ numberFormatDecimal(calAmountBranchAll(report_data)) }} บาท</h5>
            </th>
          </tr>
        </table>
      </div>
    </div>
  </section>
</template>


<script>
/* eslint-disable */
import moment from 'moment'
import api from '../services/service_report'
import apiItem from '../services/service_price_item'
import apipos from '../services/service_pos'
import apiCus from '@/services/service_customer'

export default {
  data () {
    return {
      report_data: [],
      startDate: moment(new Date()),
      endDate: moment(new Date()),
      header: {
        headers: {
          'Access-Token': sessionStorage.token
        }
      },
      form_data: '',
      branch: 0,
      host_list: [],
      host: null,
      data_cus_list: [],
      begin_code: '',
      end_code: '',
      begin_group: '',
      end_group: '',
      dyn_address: '',
      item_group_list: []
    }
  },
  methods: {
    onSelectBranch (val) {
      console.log(val)
      this.dyn_address = val.dyn_address
      this.getCus()
    },
    filterOption (input, option) {
      return (
        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      );
    },
    filterOption1 (input, option) {
      // console.log(input, option)
      return (
        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      );
    },
    getReport () {
      var branch = 0
      this.report_data = []
      this.form_data = ''
      if (this.branch !== 0) {
        branch = this.branch.id
      }
      var obj = {
        id: branch,
        begin_date: this.dateDMY(this.startDate),
        end_date: this.dateDMY(this.endDate),
        // begin_date: '2020-08-01',
        // end_date: '2020-09-01',
        company_id: 1,
        branch_id: 1,
        // begin_code: '0236',
        // end_code: '0236',
        begin_code: String(this.begin_code),
        end_code: String(this.end_code),
        begin_group: String(this.begin_group),
        end_group: String(this.end_group),
        keyword: ''
      }
      this.$store.state.isLoading = true
      api.reportSaleCustomer(
        sessionStorage.Url,
        this.header,
        obj,
        result => {
          console.log(result)
          // this.$store.commit('Loading')
          if (result.response === 'success') {
            this.$store.state.isLoading = false
            this.report_data = result.data
            console.log(this.report_data.length)
            this.form_data = JSON.stringify(this.report_data)
            console.log(this.form_data)
          } else {
            this.$store.state.isLoading = false
            this.$notification['warning']({
              message: 'ดึงข้อมูลรายงานไม่ได้',
              description: result.message
            })
          }
        },
        error => {
          this.$store.state.isLoading = false
          this.alert_msg('warning', 'ไม่สามารถเข้าถึงข้อมูล', error.message)
        }
      )
    },
    timeFormat (str) {
      return moment(str).format('HH:mm:ss')
    },
    getHost () {
      apipos.getHostShift(
        sessionStorage.Url,
        this.header,
        result => {
          // this.$store.commit('Loading')
          if (result.response === 'success') {
            this.host_list = result.data
            this.host = this.host_list[0]
            this.$store.state.isLoading = false
            // this.getReport()
          } else {
            this.alert_msg('warning', 'ดึงข้อมูลจุดขายไม่ได้', result.message)
            this.$store.state.isLoading = false
          }
        },
        error => {
          this.alert_msg('warning', 'ไม่สามารถเข้าถึงข้อมูล', error.message)
          this.$store.state.isLoading = false
        }
      )
    },
    calQTY (obj) {
      var total = 0
      obj.forEach(v => {
        total += v['qty']
      })
      return total
    },
    calAmount (obj) {
      var total = 0
      obj.forEach(v => {
        total += v['amount']
      })
      return total
    },
    calAmountBranch (obj) {
      var total = 0
      obj.forEach(v => {
        total += v['total_amount']
      })
      return total
    },
    calAmountBranchAll (obj) {
      var total = 0
      // obj.forEach(v => {
      //   v.forEach(val => {
      //     total += val['total_amount']
      //   })
      // })
      return total
    },
    capEnter () {
      $('a').on('keyup', function (e) {
        if (e.which == 13) {
          console.log(e.target.href)
        }
      })
    },
    getCus () {
      this.$store.state.isLoading = true
      let body = {
        'keyword': '',
        'limit': 1000000,
        'status': 1
      }
      apiCus.listAll(
        this.dyn_address + '/',
        {
          headers: {
            'Access-Token': this.branch.access_token
          }
        },
        // this.header,
        body,
        result => {
          // this.$store.commit('Loading')
          if (result.response === 'success') {
            this.data_cus_list = result.data
            this.$store.state.isLoading = false
          } else {
            this.$store.state.isLoading = false
            this.alert_msg('warning', 'ดึงข้อมูลลูกหนี้', result.message)
          }
        },
        error => {
          // this.$store.commit('Loading')
          this.alert_msg('warning', 'ไม่สามารถเข้าถึงข้อมูล', error.message)
        }
      )
    },
    getGroupItem () {
      apiItem.itemGroup(
        sessionStorage.Url,
        {
          headers: {
            'Access-Token': sessionStorage.token
          }
        },
        {},
        result => {
          if (result.response === 'success') {
            this.item_group_list = result.data
          } else {
            this.alert_msg('warning', 'ดึงข้อมูลลูกหนี้', result.message)
          }
        },
        error => {
          this.alert_msg('warning', 'ไม่สามารถเข้าถึงข้อมูล', error.message)
        }
      )
    }
  },
  mounted () {
    this.checkUser()
    this.getHost()
    this.getBranch()
    setTimeout(() => {
      this.branch = this.$store.state.branch_list[0]
      this.dyn_address = this.$store.state.branch_list[0].dyn_address
      this.getGroupItem()
      this.getCus()
    }, 500)
  }
}
</script>
<style scoped>
.head_table {
  background-color: #ffffad;
}
.head-branch {
  font-size: 18px;
  color: rgb(0, 0, 0);
  font-weight: bold;
}
.table .thead-dark th {
  color: #000000;
  background-color: #ffffad;
  border-color: #ffffad;
}
.table .thead-footer th {
  color: #000000;
  text-align: center;
  background-color: #ffff;
}
#sendMoney .table tr,
.table td,
.table th {
  padding: 0;
  vertical-align: top;
  border-top: 0px solid #dee2e6;
}
</style>



// WEBPACK FOOTER //
// src/views/report_sale_by_customer.vue